import { useMultiAuth } from './hybrid-apollo-client';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClientLogger } from '../client-logger';
import { useQueryPersistence } from '../../components';

const DEBUG = true;

export function CognitoLoginCallbackPage() {
  const { authObject, isLoading } = useMultiAuth();
  const navigate = useNavigate();
  const { paramsForCurrentUser } = useQueryPersistence();

  useEffect(() => {
    DEBUG &&
      ClientLogger.debug('CognitoLoginCallbackPage', 'useEffect', {
        authObject,
      });
    if (authObject?.mode === 'cognito' && isLoading === false) {
      const encodedState = authObject.user_payload.state;
      if (typeof encodedState === 'string') {
        const originalPath = decodeURIComponent(encodedState);
        // TODO: We might want to redirect to the pre-redirect page using this
        navigate('/');
      } else {
        navigate('/');
      }
    }
  }, [authObject.mode, isLoading]);

  DEBUG &&
    ClientLogger.debug('CognitoLoginCallbackPage', 'render', {
      authObject,
      paramsForCurrentUser,
    });
  return <div>Loading...</div>;
}

export function CognitoLogoutCallbackPage() {
  const { cognitoAuthObject } = useMultiAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Just to make sure, we remove the local cookies even though `signoutRedirect` should have already
    cognitoAuthObject.removeUser().finally(() => {
      // Go back to the root page.
      navigate('/');
    });
  }, [cognitoAuthObject, navigate]);

  return <div>Logging you out...</div>;
}
